import React from "react";

export const SearchBarDesktop = ({ onChangeCode }) => {
  const onChangeData = (e) => {
    onChangeCode(e.target.value);
    //alert(e.target.value);
  };
  const handleKeyDown = () => {
    return;
  };

  return (
    <>
      <div class="search-new hidden-mobile-main show-table-main">
        <div class="input-sm-new input-new-25">
          <input
            type="email"
            class="form-control input-sm"
            id="email-addr"
            placeholder="Tên, SĐT, CCCD khách hàng 1"
            onChange={onChangeData}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div class="input-sm-new input-new-18 search-main-new">
          <button type="submit" class="btn btn-info-new">
            <i class="la la-search"></i>
          </button>
        </div>
      </div>

      <div class="iconbutton-new hidden-mobile-main show-table-main">
        <div class="row">
          <div class="col-md-12">
            <h4 class="form-section">
              Chức năng này dùng để tra cứu khách hàng có nợ xấu trên hệ thống
              Morman hay không, giúp bạn giảm thiểu rủi ro trước khi đưa ra
              quyết định duyệt vay cho khách hàng
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};
